import styled from 'styled-components';
import { Typography } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { getClassName } from '../helpers';

export function Title() {
  const { widgetTitle, widgetTitleTextStyle, widgetTitleColor } = useSettings();

  if (!widgetTitle) {
    return null;
  }

  return (
    <Component textStyle={widgetTitleTextStyle} color={widgetTitleColor}>
      {widgetTitle}
    </Component>
  );
}

const Component = styled(Typography).attrs({
  className: getClassName('title', 'component')
})`
  margin-bottom: 32px;
`;
